import { render, staticRenderFns } from "./MedTable.vue?vue&type=template&id=4d5e5e82"
import script from "./MedTable.vue?vue&type=script&lang=js"
export * from "./MedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports